/**
 * Safe localStorage helpers.
 *
 * This app historically stored some string values using JSON.stringify(),
 * which means the stored value might look like "\"abc123\"" instead of "abc123".
 * These helpers make reads backward-compatible and prevent JSON.parse crashes
 * when a raw (non-JSON) string is stored.
 */

/**
 * Load a string from localStorage.
 * - If the stored value is JSON-encoded (e.g. "\"abc\""), it returns the decoded string.
 * - If the stored value is a raw string (e.g. "abc"), it returns it as-is.
 * - If the key is missing, returns null.
 */
export function loadString(key) {
  const raw = localStorage.getItem(key);
  if (raw == null) return null;

  const trimmed = raw.trim();
  if (!trimmed) return "";

  try {
    const parsed = JSON.parse(trimmed);
    if (parsed == null) return null;
    return typeof parsed === "string" ? parsed : String(parsed);
  } catch {
    return raw;
  }
}

/**
 * Save a string to localStorage as a plain string (no JSON encoding).
 */
export function saveString(key, value) {
  localStorage.setItem(key, String(value));
}


